import { render } from "./reception-hours.vue?vue&type=template&id=e1a157a0&scoped=true"
import script from "./reception-hours.vue?vue&type=script&lang=js"
export * from "./reception-hours.vue?vue&type=script&lang=js"

import "./reception-hours.vue?vue&type=style&index=0&id=e1a157a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1a157a0"]])

export default __exports__